import http from '@/api/http';

export default {
  //0机房列表
  getPoolList: (opts = {}) => {
    let prepage_count = 9;
    if (opts.prepage_count != undefined) {
      prepage_count = opts.prepage_count;
    }
    return http.get('/host/manage/v1/pool/list', {
      query: {
        page: opts.page,
        prepage_count: prepage_count,
        mid: opts.mid,
        pid: opts.pid || null,
        name: opts.name || null,
      },
    });
  },
  //0机房概要
  getPoolSumInfo: (opts = {}) => {
    return http.get('/host/manage/v1/pool/info_sum', {
      query: {
        mid: opts.mid,
        pid: opts.pid,
      },
    });
  },
  //0添加机房
  addPool: (opts = {}) => {
    return http.post('/host/manage/v1/pool/add', {
      body: {
        name: opts.name,
        abbrev: opts.abbrev,
        mid: opts.mid,
        svr_style: 1, //1-自营 2-企业 3-个人
      },
    });
  },
  //1机房详情
  getPoolDetail: (opts = {}) => {
    return http.get('/host/manage/v1/pool/info_sum', {
      query: {
        mid: opts.mid,
        pid: opts.pid,
      },
    });
  },
  //1机房详情编辑
  setPoolDetail: (opts = {}) => {
    return http.post('/host/manage/v1/pool/edit', {
      body: {
        mid: opts.mid,
        pid: opts.pid,
        name: opts.name,
        ip_list: opts.ip_list,
      },
    });
  },
  //修改Pool上下架状态
  editPoolStatus: (opts = {}) => {
    return http.post('/host/manage/v1/pool/status_edit', {
      body: {
        mid: opts.mid,
        pid: opts.pid,
        status_app: opts.status_app,
        status_pc: opts.status_pc,
      },
    });
  },
  //修改Pool类型
  editPoolType: (opts = {}) => {
    return http.post('/host/manage/v1/pool/type_edit', {
      body: {
        mid: opts.mid,
        pid: opts.pid,
        type: opts.type,
        online: opts.online,
      },
    });
  },
  //修改Pool信息
  editPool: (opts = {}) => {
    return http.post('/host/manage/v1/pool/edit', {
      body: {
        mid: opts.mid,
        pid: opts.pid,
        name: opts.name,
        ip_list: opts.ip_list,
        location_id: opts.location_id,
        location: opts.location,
        style: opts.style,
        svr_style: opts.svr_style,
        svr_name: opts.svr_name,
        info: opts.info,
        director: opts.director,
        phone: opts.phone,
        address: opts.address,
        online_rule: opts.online_rule,
        image_path: opts.img,
      },
    });
  },
  //2机房队列管理-tab队列
  getLineList: (opts = {}) => {
    return http.get('/host/manage/v1/poolqueue/list', {
      query: {
        mid: opts.mid,
        pid: opts.pid,
      },
    });
  },
  //2机房队列管理-tab开启/暂停
  editOpenStop: (opts = {}) =>
    http.post('/host/manage/v1/poolqueues/state_edit', {
      body: {
        mid: opts.mid,
        pid: opts.pid,
        qids: opts.qids,
        state: opts.state, //1  2  0
      },
    }),
  //2机房队列管理-tab设置队列
  editLineList: (opts = {}) =>
    http.post('/host/manage/v1/poolqueues/edit', {
      body: {
        mid: opts.mid,
        pid: opts.pid,
        del_queues: opts.del,
        add_queues: opts.add,
      },
    }),
  //2机房队列管理-table列表
  getLineComputerList: (opts = {}) => {
    return http.get('/host/manage/v1/vhost/list', {
      query: {
        mid: opts.mid,
        pid: opts.pid,
        qid: opts.qid,
        page: opts.page,
        prepage_count: opts.pageSize,
        sort: opts.sort,
        order: opts.order,
        ip: opts.ip,
        serial: opts.serial,
        state: opts.state,
        gid: opts.gid,
        bside: opts.bside,
      },
    });
  },
  //2机房队列管理-table暂停服务
  stopLineComputer: (opts = {}) =>
    http.post('/host/manage/v1/vhost/act', {
      body: {
        mid: opts.mid,
        gid: opts.gid,
        state: opts.state,
      },
    }),
  //2机房队列管理-table暂停服务
  stopLineComputers: (opts = {}) =>
    http.post('/host/manage/v1/vhost/acts', {
      body: {
        mid: opts.mid,
        gids: opts.gids,
        state: opts.state,
      },
    }),
  //2机房队列管理-table自动重启机器
  autoRestartComputer: (opts = {}) =>
    http.post('/host/manage/v1/vhost/restart', {
      body: {
        mid: opts.mid,
        gids: opts.gids,
      },
    }),
  //2机房队列管理-table机器分配
  distributionComputer: (opts = {}) =>
    http.post('/host/manage/v1/vhostqueue/edit', {
      body: {
        mid: opts.mid,
        gid: opts.gid,
        qid: opts.qid,
      },
    }),
  //3机房宿主机器列表
  getComputerList: (opts = {}) => {
    return http.get('/host/manage/v1/machine/list', {
      query: {
        mid: opts.mid,
        pid: opts.pid,
        page: opts.page,
        prepage_count: opts.pageSize,
        sort: opts.sort,
        order: opts.order,
        ip: opts.ip,
        serial: opts.serial,
      },
    });
  },
  //3机房宿主机重启终端
  restartTerminal: (opts = {}) =>
    http.post('/host/manage/v1/vhost/restart', {
      body: {
        mid: opts.mid,
        gids: opts.gids || [],
      },
    }),
  //3机房宿主机重启机器
  restartComputer: (opts = {}) =>
    http.post('/host/manage/v1/machine/restart', {
      body: {
        mid: opts.mid,
        ssp: opts.ssp,
        mac: opts.mac,
        vid: opts.vid,
        rid: opts.rid,
      },
    }),
  //3删除客户机
  deleteVHost: (opts = {}) =>
    http.post('/host/manage/v1/vhost/delete', {
      body: {
        mid: opts.mid,
        gid: opts.gid,
      },
    }),
  //========
  //11队列标签列表
  getTagList: (opts = {}) =>
    http.get(`/host/manage/v1/allqueue/list`, {
      query: {
        page: opts.page,
        prepage_count: opts.limit || 15,
        mid: opts.mid,
      },
    }),
  //11添加/编辑队列
  addEditList: (opts = {}) =>
    http.post('/host/manage/v1/queue/addedit', {
      body: {
        mid: opts.mid,
        qid: opts.qid || null,
        name: opts.name,
        info: opts.info,
        borrow: opts.borrow,
        apply_rate: opts.apply_rate,
        virt_switch: opts.virt_switch,
      },
    }),
  //11删除队列
  deleteLineList: (opts = {}) =>
    http.post('/host/manage/v1/queue/del', {
      body: {
        mid: opts.mid,
        qid: opts.qid,
      },
    }),
  //11设置备注
  addVHostRemark: (opts = {}) =>
    http.post('/host/manage/v1/vhost/addremark', {
      body: {
        gid: opts.gid,
        remark: opts.remark,
      },
    }),
  //11设置备注
  hostReboot: (opts = {}) =>
    http.post('/host/manage/v1/host/reboot', {
      body: {
        mid: opts.mid,
        pid: opts.pid,
        mode: opts.mode,
        gids: opts.gids,
      },
    }),
  //导出
  requestExport: (opts = {}) =>
    http.get('/host/manage/v1/vhost/export', {
      query: {
        mid: opts.mid,
        pid: opts.pid,
        state: opts.state,
      },
    }),
};
